import { FC } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

export enum DiagnosticStatus {
  NOT_READY = 'NOT_READY',
  HALF_READY = 'HALF_READY',
  READY = 'READY',
}

export type DiagnosticCounterProps = {
  status: DiagnosticStatus;
  count: number;
};

const COLORS_BY_STATUS: Record<DiagnosticStatus, { background: string; primary: string }> = {
  [DiagnosticStatus.READY]: { background: COLORS.successBackground, primary: COLORS.success },
  [DiagnosticStatus.HALF_READY]: { background: COLORS.warningBackground, primary: COLORS.warning },
  [DiagnosticStatus.NOT_READY]: { background: COLORS.dangerBackground, primary: COLORS.danger },
};

export const DiagnosticCounter: FC<DiagnosticCounterProps> = ({ status, count }) => {
  return (
    <>
      <Container status={status}>{count}</Container>
    </>
  );
};

const Container = styled.div<{
  status: DiagnosticStatus;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  height: 26px;
  border-radius: 6px;
  padding: 1px 8px;

  border: 1px solid ${({ status }) => COLORS_BY_STATUS[status].primary};
  color: ${({ status }) => COLORS_BY_STATUS[status].primary};
  background-color: ${({ status }) => COLORS_BY_STATUS[status].background};
  font-size: 16px;
  font-weight: 400;
`;
